// Windsurf generated file
import axiosInstance from './interceptor.tsx'

const API_BASE_URL = '/feature-flags'

// Windsurf generated
export enum FeatureFlagName {
  ENABLE_PARTIAL_MATURITIES = 'ENABLE_PARTIAL_MATURITIES',
  ENABLE_PROPOSAL_DESCRIPTIONS = 'ENABLE_PROPOSAL_DESCRIPTIONS',
  ENABLE_DEV_TOOLS = 'ENABLE_DEV_TOOLS',
  ENABLE_PARTIAL_MATURITIES_BY_DOLLAR_AMOUNT = 'ENABLE_PARTIAL_MATURITIES_BY_DOLLAR_AMOUNT',
  ENABLE_ISSUER_STATUS = 'ENABLE_ISSUER_STATUS',
}

export type FeatureFlags = Record<FeatureFlagName, boolean>

/**
 * Fetches a feature flag value from the API
 * @param flagName - The name of the feature flag to fetch
 * @returns Promise resolving to boolean value
 */
export const getFeatureFlag = async (flagName: string): Promise<boolean> => {
  try {
    const response = await axiosInstance.get<boolean>(
      `${API_BASE_URL}/${flagName}`
    )
    return response.data
  } catch (error) {
    console.error(`Error fetching feature flag ${flagName}:`, error)
    // Default to false if there's an error
    return false
  }
}

/**
 * Default feature flags - defines all available flags and their default values.
 * This is the single source of truth for feature flags on the frontend.
 * To add a new flag: add it to the FeatureFlagName enum and here with its default value (typically false).
 */
export const defaultFlags: FeatureFlags = {
  [FeatureFlagName.ENABLE_PARTIAL_MATURITIES]: false,
  [FeatureFlagName.ENABLE_PROPOSAL_DESCRIPTIONS]: false,
  [FeatureFlagName.ENABLE_DEV_TOOLS]: false,
  [FeatureFlagName.ENABLE_PARTIAL_MATURITIES_BY_DOLLAR_AMOUNT]: false,
  [FeatureFlagName.ENABLE_ISSUER_STATUS]: false,
}

/**
 * Fetches all known feature flags dynamically based on the FeatureFlags interface.
 * Add new flags to the defaultFlags object above - no changes needed here.
 */
export const getAllFeatureFlags = async (): Promise<FeatureFlags> => {
  const flagNames = Object.keys(defaultFlags) as Array<keyof FeatureFlags>

  const flagValues = await Promise.all(
    flagNames.map(async (flagName) => ({
      name: flagName,
      value: await getFeatureFlag(flagName),
    }))
  )

  return flagValues.reduce(
    (acc, { name, value }) => ({ ...acc, [name]: value }),
    {} as FeatureFlags
  )
}
